import React, { useState, useEffect } from 'react';
// Importamos las funciones del service
import { obtenerReseñasPublicas, crearReseña } from '../../services/ResenasService';

import '../static/Reseñas.css';
import '../static/Perfil.css';
import '../static/Global.css';

function Reseñas() {
    const [showModal, setShowModal] = useState(false);
    const [reseñas, setReseñas] = useState([]); // Estado para las reseñas de la BD
   const [loading, setLoading] = useState(true);

    // 1. Cargar reseñas al montar el componente
    useEffect(() => {
        cargarReseñas();
    }, []);

    const cargarReseñas = async () => {
        try {
            const data = await obtenerReseñasPublicas();
            setReseñas(data);
        } catch (error) {
            console.error("Error al cargar reseñas:", error);
        } finally {
            setLoading(false);
        }
    };

    // 2. Enviar nueva reseña
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        
        const nuevaData = {
            nombre: formData.get('fullName'),
            correo: formData.get('email'),
            comentario: formData.get('message'),
            puntuacion: parseInt(formData.get('rating')) || 5 // Por defecto 5 si no marca
        };

        try {
            const res = await crearReseña(nuevaData);
            if (res.success) {
                setShowModal(true);
                event.target.reset();
                // Nota: No la agregamos al estado 'reseñas' inmediatamente 
                // porque 'visibilidad' es FALSE por defecto en la BD.
            }
        } catch (error) {
            alert("Hubo un error al enviar tu reseña. Inténtalo de nuevo.");
        }
    };

    const closeReseñaModal = () => setShowModal(false);

    // Función auxiliar para convertir número a estrellas de texto
    const renderEstrellas = (num) => "★".repeat(num) + "☆".repeat(5 - num);

    return (
        <main className="main__section">
            <h1 className="main__title">Reseñas</h1>

            <form id="reseñaForm" className="review-card container-xxl p-4 p-md-5" onSubmit={handleSubmit}>
                <div className="row g-4 align-items-start">
                    <div className="col-12 col-md-1 d-flex justify-content-center">
                        <div className="avatar-circle"></div>
                    </div>

                    <div className="col-12 col-md-11">
                        <div className="row g-4">
                            <div className="col-12 col-lg-6">
                                <label className="form-label fw-semibold">Nombre y Apellidos:</label>
                                <input className="form-control pill-input" name="fullName" placeholder="Tu nombre" required />
                            </div>

                            <div className="col-12 col-lg-6">
                                <label className="form-label fw-semibold">Correo Electrónico:</label>
                                <input className="form-control pill-input" type="email" name="email" placeholder="correo@ejemplo.com" required />
                            </div>

                            <div className="col-12">
                                <textarea className="form-control soft-area" name="message" rows="5" placeholder="Escribe tu reseña..." required></textarea>
                            </div>

                            <div className="col-12 col-lg-6 d-flex align-items-center gap-3">
                                <span className="fw-semibold fs-5">Tu puntuación:</span>
                                <div className="rating-stars">
                                    {[5, 4, 3, 2, 1].map((num) => (
                                        <React.Fragment key={num}>
                                            <input type="radio" id={`star${num}`} name="rating" value={num} defaultChecked={num === 5} />
                                            <label htmlFor={`star${num}`} title={`${num} estrellas`}>★</label>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>

                            <div className="col-12 col-lg-6 d-flex justify-content-lg-end">
                                <button type="submit" className="pill-btn px-4 py-2">
                                    ENVIAR RESEÑA <i className="fa-solid fa-angle-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            {/* MODAL DE AGRADECIMIENTO */}
            {showModal && (
                <div className="modal" style={{ display: 'flex', backgroundColor: 'rgba(0,0,0,0.5)', position: 'fixed', top:0, left:0, width:'100%', height:'100%', zIndex: 1000 }} onClick={closeReseñaModal}>
                    <div className="modal-content text-center m-auto p-4" style={{ maxWidth: '400px', backgroundColor: '#fff', borderRadius: '15px' }} onClick={(e) => e.stopPropagation()}>
                        <h3 className="fw-bold mb-3">¡Gracias!</h3>
                        <p>Tu reseña ha sido recibida. Será visible una vez sea aprobada por nuestro equipo.</p>
                        <button type="button" className="btn btn-dark pill-btn px-4 mt-3" onClick={closeReseñaModal}>
                            ENTENDIDO
                        </button>
                    </div>
                </div>
            )}

{/* SECCIÓN DE RESEÑAS LISTADAS */}
<section className="row justify-content-center mt-5">
    {loading ? (
        /* CASO 1: Está cargando */
        <div className="loader-wrapper">
            <div className="novatech-spinner"></div>
            <span className="loader-text">Cargando reseñas...</span>
        </div>
    ) : reseñas.length > 0 ? (
        /* CASO 2: Ya cargó y HAY reseñas */
        reseñas.map((res) => (
            <div className="col-lg-8 col-md-10" key={res.id}>
                <div className="formulario p-4 mb-3">
                    <div className="d-flex align-items-center mb-2">
                        <div className="icono-usuario me-2"></div>
                        <span className="nombre-usuario fw-bold me-3">{res.nombre}</span>
                        <span className="estrellas-llenas text-warning">
                            {renderEstrellas(res.puntuacion)}
                        </span>
                    </div>
                    <p className="mb-0">{res.comentario}</p>
                </div>
            </div>
        ))
    ) : (
        /* CASO 3: Ya cargó pero NO hay reseñas */
        <p className="text-center">Aún no hay reseñas aprobadas. ¡Sé el primero!</p>
    )}
</section>
        </main>
    );
}

export default Reseñas;